import { l as loadFormbricksToProxy } from "./loadFormbricks-DaeJP_pg.js";
const formbricksProxyHandler = {
  get(_target, prop, _receiver) {
    return (...args) => loadFormbricksToProxy(prop, "app", ...args);
  }
};
const formbricksApp = new Proxy({}, formbricksProxyHandler);
export {
  formbricksApp as default
};
//# sourceMappingURL=app.js.map
